<template>
  <nav :id="tese">
    <div>
      <img src="../assets/Icon.png" alt="Logo" />
    </div>
    <img
      v-if="isMobile"
      :class="['nav__more', { active: moreOptions }]"
      src="../assets/bars-solid.svg"
      alt="Mais Ações"
      @click="toggleMoreOptions"
    />
    <div class="dropdown" v-show="showDropdown">
      <div id="navLinks">
        <router-link to="/">
          <p>Pagina inicial</p>
        </router-link>
        <router-link to="/oas">
          <p :class="active">Objetos de Aprendizagem</p>
        </router-link>
        <router-link to="/sobre">
          <p>Sobre</p>
        </router-link>
      </div>
      <div>
        <template v-if="isAuthenticated">
          <div class="user-info">
            <p class="username" @click="goToProfile" style="cursor: pointer">
              {{ getUser?.public_name || "username" }}
            </p>
            <button @click="logoutAndRedirect" class="btnAcess lgtbt">
              Sair
            </button>
          </div>
        </template>
        <template v-else>
          <div class="auth-buttons">
            <router-link to="/login">
              <button type="button" class="btnAcess btnLog">
                <span class="logbt">Login</span>
              </button>
            </router-link>
            <router-link to="/register">
              <button type="button" class="btnAcess">
                <span>Crie sua conta</span>
              </button>
            </router-link>
          </div>
        </template>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "MyNavBar",
  props: {
    theme: {
      required: false,
      type: String,
      default: "light",
    },
  },
  data() {
    return {
      tese: this.theme,
      moreOptions: false,
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated", "hasBaoBahUser", "getUser"]),

    isMobile() {
      return this.windowWidth < 816;
    },

    showDropdown() {
      // Se for mobile, controla pela variável moreOptions
      if (this.isMobile) return this.moreOptions;
      // Se for desktop, dropdown sempre visível
      return true;
    },
  },
  methods: {
    ...mapActions(["logout"]),

    toggleMoreOptions() {
      this.moreOptions = !this.moreOptions;
    },

    async logoutAndRedirect() {
      try {
        await this.logout();
        this.$router.push("/").then(() => {
          window.location.reload();
        });
      } catch (error) {
        console.error("Erro durante logout:", error);
        this.$router.push("/");
        window.location.reload();
      }
    },

    goToProfile() {
      if (this.hasBaoBahUser) {
        this.$router.push(`/profile/${this.getUser.id}`);
      } else {
        alert("Você precisa estar logado!");
      }
    },

    handleClickOutside(event) {
      const dropdown = this.$el.querySelector(".dropdown");
      const moreBtn = this.$el.querySelector(".nav__more");

      if (
        this.moreOptions &&
        !dropdown.contains(event.target) &&
        !moreBtn.contains(event.target)
      ) {
        this.moreOptions = false;
      }
    },

    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
      if (!this.isMobile) {
        this.moreOptions = false;
      }
    },
  },
  mounted() {
    window.addEventListener("resize", this.updateWindowWidth);
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateWindowWidth);
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 2rem;
}

.dropdown {
  display: flex;
  background-color: white;
  flex-direction: column;
  position: absolute;
  top: 5rem;
  right: 0;
  padding: 1rem;
  width: 50vw;
  border-radius: 0 0 1rem 1rem;
}

.active {
  transform: rotate(-90deg);
}

.nav__more {
  width: 2rem;
  height: auto;
  cursor: pointer;
  transition: all ease-in-out 0.1s;
}

.active p {
  font-weight: bold;
}

#dark {
  background-color: var(--terracota);
}

#dark a {
  color: var(--white);
}

#light {
  background-color: var(--white);
}

#light a p {
  color: var(--terracota);
}

#navLinks {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 2rem;
}

.btnAcess {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 44px;
  padding: 16px 24px;
  background-color: var(--terracota);
  gap: 5px;
  border: none;
  border-radius: 30px;
  color: var(--white);
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.3s ease, color 0.3s ease; /* Efeito suave */
}

.btnAcess:hover {
  background-color: lightgreen; /* Verde claro no hover para o botão de registro */
}

.auth-buttons {
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.username {
  color: var(--terracota);
  font-weight: bold;
}

.auth-buttons a {
  display: inline-block;
}

/* Estilo do botão de login */
.btnLog {
  background-color: transparent; /* Fundo transparente */
  color: var(--terracota); /* Cor inicial do texto */
  border: none;
  cursor: pointer;
  font-weight: bold;
  font-size: 16px;
  transition: color 0.3s ease; /* Efeito suave para a cor do texto */
}

/* Hover no botão de login */
.btnLog:hover span {
  color: lightgreen; /* Texto muda para verde claro no hover */
}

.btnLog:hover {
  background-color: transparent; /* Fundo permanece transparente no hover */
}

.lgtbt:hover {
  background-color: darkred;
}

.logbt {
  color: var(--terracota);
}

@media screen and (min-width: 816px) {
  nav {
    padding: 10px 3rem;
  }

  .dropdown {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    flex-direction: row;
    position: inherit;
    padding: 0;
  }

  #navLinks {
    justify-content: center;
    flex: 1;
    flex-direction: row;
    gap: 1.5rem;
    align-items: center;
    padding: 1rem;
  }

  .auth-buttons {
    flex-direction: row;
  }
}

@media screen and (min-width: 1024px) {
  nav {
    padding: 10px 80px;
  }

  #navLinks {
    gap: 50px;
    padding: 0;
  }
}
</style>
